<script setup lang="ts">
const { page } = useContent()
defineProps<{ id: string }>()
const isAPISidebar = page.value?.sidebar == 'API'
</script>

<template>
  <h3 :id="id" :class="[{ 'sphinx-function': isAPISidebar }, { 'font-semibold': !isAPISidebar }]">
    <NuxtLink :href="`#${id}`">
      <slot />
    </NuxtLink>
  </h3>
</template>

<style lang="postcss" scoped>
h3 {
  color: var(--color-gray-900);
  margin-top: 2rem;
  margin-bottom: 1rem;
  scroll-margin-top: calc(var(--spacing-header) + 4.5rem);
  font-size: var(--text-xl);
  line-height: var(--leading-snug);
  letter-spacing: var(--tracking-tight);

  @media (min-width: 640px) {
    scroll-margin-top: calc(var(--spacing-header) + 2rem);
  }

  &+* {
    margin-top: 0;
  }

  &>a {
    position: relative;

    &::before {
      content: "";
      position: absolute;
      bottom: -2px;
      left: 2px;
      height: 1px;
      width: calc(100% - 4px);
    }

    &:hover {
      &::before {
        border-bottom: 1px dashed var(--color-gray-900);
      }

      &::after {
        position: absolute;
        right: -0.9em;
        height: 0.7em;
        width: 0.7em;
        content: url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' fill='none' stroke='%23000' viewBox='0 0 24 24'%3E%3Cpath stroke-linecap='round' stroke-linejoin='round' stroke-width='2' d='M13.828 10.172a4 4 0 0 0-5.656 0l-4 4a4 4 0 1 0 5.656 5.656l1.102-1.101m-.758-4.899a4 4 0 0 0 5.656 0l4-4a4 4 0 0 0-5.656-5.656l-1.1 1.1'/%3E%3C/svg%3E");
      }
    }
  }
}
</style>
